import React, { FC, useEffect, useState } from 'react';
import { APP_DATE_FORMAT } from '../../../../utils/constants';

import CoverSheet from '../general/coverSheet';
import PDFPage from '../../../themed/pdf/pdfPage';
import VIPDFData from './viPDFData';
import VisualInspectionInfoSheet from './visualInspectionInfoSheet';

import withPDF from '../../../hoc/withPDF';

import * as models from '../../../../utils/models';
import * as data from '../../../../utils/data';
import * as utils from '../../../../utils/utilities';

interface VIReportProps {
	viCoverData: models.VICustomCoverData;
	viReportItems: models.VIReportItem[];
	viReportSummary: models.VIReportSummaryData;
	viPhoto: models.PDFImageProps[];
	projectDetails: models.Project;
	showAnomalyPage: boolean;
}

const VisualInspectionReport: FC<VIReportProps> = (props): JSX.Element => {
	const [overview, setOverview] = useState<models.CoverDataOverview[]>([]);

	const { documentNumber, report } = props.projectDetails;

	const standardCriteriaItems: models.CoverDataItem[] = props.viCoverData.coverData.map((item, index) => ({
															label: `${index + 1}. ${item.id}`,
															value: item.name.toString(),
														  }));

	const referenceDocuments: models.CoverDataItem[] = [
		{
			label: '1. Scope Of Work',
			value: props.viCoverData?.scopeOfWork,
		},
	];

	const pageSubtitle: string = 'Document Number: ' + documentNumber;

	useEffect(() => {
		const overviewData = props.showAnomalyPage
			? data.getVTCoverOverview()
			: overviewWithoutAnomaly;
		setOverview(overviewData);
	}, [props.showAnomalyPage]);

	return (
		<React.Fragment>
			<VisualInspectionInfoSheet
				reportInspectionType={props.projectDetails.inspectionTypeName}
				companyUrl={props.projectDetails.organisation.organisationLogo}
				documentNo={props.projectDetails.documentNumber}
				clientName={props.projectDetails.organisationName}
				facility={props.projectDetails.facilityName}
				inspectorName={props.projectDetails.report.creatorName}
				reportTitle={props.projectDetails.projectTitle}
				reviewerName={props.projectDetails.review.reviewerName}
				approverName={report.approvedByName}
				approvalDate={
					report.approvedDate
						? utils.formatTime(report.approvedDate, APP_DATE_FORMAT)
						: null
				}
			/>

			<PDFPage
				pageDetails={utils.getPageDetails('Cover Sheet', pageSubtitle)}
				projectDetails={props.projectDetails}
			>
				<CoverSheet
					overviewData={overview}
					referenceDocuments={referenceDocuments}
					standardCriteriaItems={standardCriteriaItems}
				/>
			</PDFPage>

			<VIPDFData
				data={props.viReportItems}
				images={props.viPhoto}
				summary={props.viReportSummary?.summary}
				remarks={props.viReportSummary?.remarks}
				project={props.projectDetails}
				showAnomalyPage={props.showAnomalyPage}
			/>
		</React.Fragment>
	);
};

const overviewWithoutAnomaly: models.CoverDataOverview[] = [
	{ report: '1. Cover Sheet', required: 'Yes', page: '3' },
	{ report: '2. Summary Sheet', required: 'Yes', page: '4' },
	{
		report: '3. Photographic Report',
		required: 'Yes',
		page: 'N/A',
	},
];

export default withPDF(VisualInspectionReport);
